export default __webpack_public_path__ + "static/media/logo.b135d376.png";